import React from 'react';

export const MicOnIcon = (props) => {
  const { className = '', style = {}, disabled = false, onClick } = props;
  return (
    <svg
      className={`custom-icon ${disabled ? 'disabled' : ''} ${className}`}
      onClick={disabled ? null : onClick}
      style={style}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0868 21.1026C18.633 21.1026 20.7128 19.0228 20.7128 16.4766V9.10261C20.7128 6.55639 18.633 4.47656 16.0868 4.47656C13.5405 4.47656 11.4607 6.55639 11.4607 9.10261V16.4766C11.4607 19.0228 13.5405 21.1026 16.0868 21.1026ZM13.3389 9.10261C13.3389 7.59001 14.5741 6.35471 16.0868 6.35471C17.5994 6.35471 18.8347 7.59001 18.8347 9.10261V16.4766C18.8347 17.9892 17.5994 19.2245 16.0868 19.2245C14.5741 19.2245 13.3389 17.9892 13.3389 16.4766V9.10261ZM17.0321 24.7329V26.611H19.78C20.2968 26.611 20.7128 27.027 20.7128 27.5438C20.7128 28.0606 20.2968 28.4766 19.78 28.4766H12.4061C11.8893 28.4766 11.4733 28.0606 11.4733 27.5438C11.4733 27.027 11.8893 26.611 12.4061 26.611H15.154V24.7329C11.0069 24.2665 7.78003 20.7497 7.78003 16.4766C7.78003 15.9598 8.196 15.5438 8.7128 15.5438C9.22961 15.5438 9.64558 15.9598 9.64558 16.4766C9.64558 20.0312 12.5321 22.9177 16.0868 22.9177C19.6414 22.9177 22.5279 20.0312 22.5279 16.4766C22.5279 15.9598 22.9439 15.5438 23.4607 15.5438C23.9775 15.5438 24.3935 15.9598 24.3935 16.4766C24.3935 20.7371 21.1666 24.2665 17.0195 24.7329H17.0321Z"
        fill="#D9ECFA"
      />
    </svg>
  );
};
